import React, {useLayoutEffect, useRef, useState} from "react";
import {CRITERIA_MODEL, SEARCH_MODEL} from "../../../../../components/table/Model/TableModel";
import {SearchByFilters} from "../../../../../reduxToolkit/Search/SearchApi";
import {useDispatch, useSelector} from "react-redux";
import {TABLES} from "../../../../../Apis/Tables";
import TableFunction from "../../../../../components/table/TableFunction";
import {VIEW_TYPE} from "../../../../../enums/ViewType";
import {useTranslation} from "react-i18next";
import {getSearchVisitorCriteriaList, visitorCriteria} from "../Model/Model";

/**
 * @Email : kpozos@ibl.mx
 * @Author: karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 * @param {Array<string>} selectedList - Currently selected invitation IDs (required).
 * @param {Function} setSelectedList - Function to update the selected invitations (required).
 * @param {Function} setCriteria - Function to update the search criteria for filters (required).
 * @param {Function} setBodyForExport - Function to define the export body payload (required).
 * @param {string} searchElement - ID or reference used for identifying the search input (required).
 * @param {Array<Object>} finalArray - Array containing applied search filters (required).
 */

export const  VisitorTabCardApp = ({
    selectedList,
    setSelectedList,
    setCriteria,
    searchElement,
    finalArray,
    setSearch,
    modified,
    setModified,
    showSuccessMsgRef
}) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [results, setResults] = useState(null); // Store the search results
    const option = TABLES.VISITOR;
    const elementRefTab1 = useRef(null); // Reference to the element for positioning (used for layout effects)

    useLayoutEffect(() => {
        if (elementRefTab1?.current) {
            const rect = elementRefTab1.current.getBoundingClientRect(); // Get the element's position on the screen
            const distanceTop = rect.top + 0; // Calculate the top position of the element
            elementRefTab1.current.style.setProperty('--top-value', `${distanceTop}px`); // Update the custom CSS property for positioning
        }
    }, [elementRefTab1?.current]); // Dependency array ensures the effect runs when the 'view' prop changes

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page, { searchElement }) => {
        const  criteriaList = searchElement  ? getSearchVisitorCriteriaList({ option, searchElement}): []
        const body = SEARCH_MODEL.setObject({
            page,
            size:rowsPerPage,
            model:option,
            criteria:[visitorCriteria(option), ...criteriaList],
            viewType:VIEW_TYPE.GRID.viewType
        });
        setCriteria(body);
        setSearch(true);
        dispatch(SearchByFilters({ option, body, showSuccessMsg: showSuccessMsgRef.current})).then(({ payload: {data: { data, success }}}) => {
                if (success === true) {
                    setResults(data);
                    showSuccessMsgRef.current = true;
                }
            },
        );
    }

    /**
     * Executes a paginated search request using advanced criteria.
     *
     * Builds the criteria list based on the advanced search (finalArray),
     * appends user criteria, and dispatches the search action through Redux.
     * Updates the results and resets the selected list once the data is returned.
     */
    const getDataAdvancedSearch = (page) => {
        const criteriaList = finalArray.map((item) => {
            return CRITERIA_MODEL.set(item);
        });
        criteriaList.push(visitorCriteria(option));
        const body = SEARCH_MODEL.setObject({page, size:rowsPerPage, model:option, criteria:criteriaList, viewType:VIEW_TYPE.GRID.viewType});
        setCriteria(body);
        dispatch(SearchByFilters({ option, body })).then(({ payload: {data: { data }}}) => {
            setResults(data);
        });
    }

    // Use the TableFunction SubComponents to handle table logic (checkbox selection, pagination, etc.)
    const { handleCheckboxChange, pagination, page, rowsPerPage} = TableFunction({
        selectedList,
        setSelectedList,
        data: results,
        labelRowsPerPage: 'visitors_per_page',
        hasContainer: true,
        fixedPagination: false,
        searchElement,
        view:VIEW_TYPE.GRID.name,

        getData,//New
        modified,//New
        setModified,//New
        getDataAdvancedSearch,//New - apply only with advanced search
        finalArray,//New - apply only with advanced search
    });

    return {
        t,
        DEV,
        permission,
        results,
        setResults,
        option,
        page,
        rowsPerPage,
        setSimpleSearch,
        elementRefTab1,
        pagination,
        handleCheckboxChange,
        getData,
    };
};
